<template>
  <div class="dx-letter-avatar">
    <h2>{{ letter }}</h2>
  </div>
</template>

<script>
export default {
  name: 'dx-letter-avatar',
  props: {
    name: String
  },
  computed: {
    letter () {
      if (this.name) {
        return this.name[0].toUpperCase()
      }
      return 'D'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxLetterAvatar.vue